import axios from 'axios';

const isDev = process.env.NODE_ENV === 'development';

const request = axios.create({
  baseURL: isDev ? '/umg' : 'https://xtray.96ck.com/umg',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

// 请求拦截器 - 自动携带 token
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    // 未登录或 token 过期，跳转登录页
    if (res.code === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      const basename = process.env.NODE_ENV === 'production' ? '/user' : '';
      window.location.href = basename + '/login';
      return Promise.reject(new Error(res.msg || '未登录'));
    }
    if (res.code && res.code !== 200) {
      return Promise.reject(new Error(res.msg || '请求失败'));
    }
    return res;
  },
  error => {
    console.error('[Network Error]', error.message);
    return Promise.reject(error);
  }
);

export default request;
